import { useDialog } from '@allurion/ui';
import { useIntl } from 'react-intl';

import { useTrackEvent } from 'src/analytics/analytics';

import { DailyActionDialog } from './DailyActionDialog';

import styles from './DailyActionInfoModal.module.scss';

type Props = {
  title: string;
  description: string;
  icon: string;
  patientId: string;
};

export function DailyActionInfoModal({ title, icon, description }: Props) {
  const intl = useIntl();
  const { openDialog, Dialog } = useDialog({
    content: () => {
      return <DailyActionDialog title={title} icon={icon} description={description} />;
    },
  });
  const { trackClick } = useTrackEvent();

  const openActionModal = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    e.stopPropagation();
    trackClick(e.currentTarget, { label: 'open-patient-daily-actions-info-dialog' });
    openDialog({
      title: intl.formatMessage({
        id: 'daily-actions.modal.title',
        defaultMessage: 'Daily Action',
      }),
      contentProps: {},
    });
  };

  return (
    <>
      <a
        className={styles.link}
        onClick={openActionModal}
        data-cy="open-patient-daily-actions-info-dialog"
      >
        {title}
      </a>
      <Dialog />
    </>
  );
}
